import BasePerimeter from "./base";

export default new BasePerimeter({
  purpose: "filters",
  govern: {
    "can viewFilterTodayAdmin": function() {
      return this.isSuperAdmin() || this.isAdmin();
    },
    "can archive": function() {
      return this.isSuperAdmin() || this.isAdmin() || this.isClientAdmin();
    }
  }
});
